import { endPoints, requestType } from "../constants/variables";
import Api from "./index";

// Worker-side calls (existing)
export const getAttendanceData = (workerId, startDate, endDate) => {
  return Api(
    `${endPoints.fetchAttendance}/${workerId}?startDate=${startDate}&endDate=${endDate}`,
    null,
    requestType.GET
  );
};

export const getAllWorkers = () => {
  return Api(endPoints.fetchWorkers, null, requestType.GET);
};

// Admin-side calls
export const getWorkerAttendanceByDate = (workerId, date) => {
  return Api(`${endPoints.getWorkerAttendance}/${workerId}/${date}`, null, requestType.GET);
};

export const adjustAttendanceRecord = (id, params) => {
  return Api(`${endPoints.adjustAttendance}/${id}`, params, requestType.PUT);
};

export const addAttendanceRecord = (params) => {
  return Api(`${endPoints.addAttendance}`, params, requestType.POST);
};

export const deleteAttendanceRecord = (id) => {
  return Api(`${endPoints.deleteAttendance}/${id}`, null, requestType.DELETE);
};

export const getWorkersAttendanceByDate = (date, workerId) => {
  let url = `${endPoints.allWorkersAttendance}/${date}`;
  if (workerId) url += `?workerId=${workerId}`;
  return Api(url, null, requestType.GET);
};

export const getAttendanceSummary = (workerId, startDate, endDate) => {
  let url = `${endPoints.attendanceSummary}?workerId=${workerId}`;
  if (startDate) url += `&startDate=${startDate}`;
  if (endDate) url += `&endDate=${endDate}`;
  return Api(url, null, requestType.GET);
};

export const getAdjustmentHistory = (params) => {
  const query = new URLSearchParams();
  if (params?.employeeId) query.append("employeeId", params.employeeId);
  if (params?.page) query.append("page", params.page);
  if (params?.limit) query.append("limit", params.limit);
  const qs = query.toString();
  const url = qs
    ? `${endPoints.adjustmentHistory}?${qs}`
    : endPoints.adjustmentHistory;
  return Api(url, null, requestType.GET);
};